
import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    rankList: [],
    myRank: {},

    rwList: [],

    // 抽奖返回数据
    betResultList: [],
    betBigResult: {}
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  // 抽奖
  @action async goBet(type = 1, num = 10) {
    let betResult = await http.post('/web/egg/bet', {
      ptype: type,
      betNum: num
    })
    if (betResult && betResult.code == 0) {
      this.data.betResultList = betResult && betResult.res && betResult.res.list
      this.data.betBigResult = betResult && betResult.res && betResult.res.bigResult
      return betResult
    }
  }

  // 排行
  @action async getRanking() {
    let rankList = await http.post('/web/egg/big/rank')
    if (rankList && rankList.code == 0) {
      this.data.rankList = rankList && rankList.res.list
      this.data.myRank = rankList && rankList.res.myRank
      return rankList
    }
  }

  // 奖品列表
  @action async getRewardList(ptype) {
    let rwList = await http.post('/web/egg/prize/list', { ptype })
    if (rwList && rwList.code == 0) {
      this.data.rwList = rwList && rwList.res
      return rwList
    }
  }

  // 抽奖记录
  @action async getRecord(scrollArg) {
    let rc = await http.post('/web/egg/record', { scroll: scrollArg })
    if (rc && rc.code == 0) {
      return rc
    }
  }

  // 用户金币
  @action async getUserGold() {
    let gold = await http.post('/web/MyAccountInfo')
    if (gold && gold.code == 0) {
      return gold
    }
  }

  // 概率
  @action async getProb() {
    let prob = await http.post('/web/egg/get/bigProbability')
    if (prob && prob.code == 0) {
      return prob
    }
  }

  // 碎片
  @action async getChip() {
    let chip = await http.post('/web/egg/get/chip')
    if (chip && chip.code == 0) {
      return chip
    }
  }

  // 商店列表
  @action async getShopList() {
    let shop = await http.post('/web/egg/shop/list')
    if (shop && shop.code == 0) {
      return shop
    }
  }

  // 兑换
  @action async canExchange(id, num) {
    let exchange = await http.post('/web/egg/exchange', { eggShopid: id, count: num })
    if (exchange && exchange.code == 0) {
      return exchange
    }
  }

  // 兑换记录
  @action async getExRecordList(scroll) {
    let exRecord = await http.post('/web/egg/exchange/record', { scroll })
    if (exRecord && exRecord.code == 0) {
      return exRecord
    }
  }
}



// WEBPACK FOOTER //
// src/store/app/geshapon.js